import CreateCollectionModal from './CreateCollectionModal.container'
export default CreateCollectionModal
